module.exports = __webpack_public_path__ + "img/grafikaNaCoDzien_1.8d159c84.png";